import { vnModule_knockoutJS } from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { header } from './header';
import { vn_app_zone_notification } from '../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification';
import { tagsImport_template } from '../components/templates/tagsImport_template';

declare var ko: any;
declare var page: any;

export class tags_import extends vnModule_knockoutJS {
    protected XHRHdl: any = {};
    public tagsImport: tagsImport_template;

    protected getModuleName(){
        return 'tags_import';
    }

    buildContent() : Array<Element> {
        this.tagsImport = new tagsImport_template('tags_import', this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = zoneHeader!.loadedModule;
        (<header>loadedModule).setHeaderTitle('Import Tags');

        this.getVnAppZone().app.params.idBrand;

        return [this.tagsImport.build()];
    }

    public fillPage(): void {
        this.tagsImport.set_idBrand(this.getVnAppZone().app.params.idBrand);

        this.getTagImportEntries();
    }

    protected paginationOnPageClick(){
        this.getTagImportEntries();
    }

    protected filterSimpleOnChange(){

        this.getTagImportEntries();
    }

    protected filterSimpleCancel(){

        this.cancelXHR('getTagImportEntries');
    }

    public filterMultipleSelectorOnChange() {
        this.getTagImportEntries();
      }

    private cancelXHR(idHdl: string) {
        if(this.XHRHdl[idHdl]) {
            this.XHRHdl[idHdl].cancelAndReset();
        }
    }

    private executeXHR(idHdl: string, url: string, params: any, onReadyStateFunction: any) {
        if(this.XHRHdl[idHdl]) {
            this.XHRHdl[idHdl].cancelAndReset();
        }

        this.XHRHdl[idHdl] = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdl[idHdl].onReadyStateFunction = onReadyStateFunction;
        this.XHRHdl[idHdl].execute();
    }

    public getTagImportEntries() {
        this.cancelXHR('getTagImportEntries');

        // LOADING : starts
        this.loadingIn(this.tagsImport.builtTemplate.children.namedItem("list-results"));

        let url = `/api/brand/${this.getBrandId()}/tags/import/`;

        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.tagsImport.getViewModelForImportEntriesRequest())] );

        this.executeXHR('getTagImportEntries', url, params, this.onGetTagImportEntriesReturn);
    }

    public onGetTagImportEntriesReturn(req : any, obj : tags_import) {
        return function () {
            const execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100;
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);
                if(response.data.results) {
                    let data = response.data.results.data;
                    let importsData = [];
                    for(let entry of data) {
                        let importEntry = null;
                        if(entry[0]) {
                            importEntry = entry[0];
                            importEntry.status = entry.status_alias;
                        } else {
                            importEntry = entry;
                        }

                        importEntry.dateCreated = obj.formatDateWithoutMilliseconds(importEntry.dateCreated.date);
                        importEntry.dateUpdated = obj.formatDateWithoutMilliseconds(importEntry.dateUpdated.date);
                        importsData.push(importEntry);
                    }
                    obj.tagsImport.updateList(
                        importsData,
                        response.data.results.totalCount,
                        response.data.results.totalPage,
                        execTime
                    );
                }

                // LOADING : ends
                obj.loadingOut(obj.tagsImport.builtTemplate.children.namedItem("list-results"));
            });
        }
    }

    private formatDateWithoutMilliseconds(date) {
        const formattedDate = new Date(date).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
        return formattedDate;
    }

    public getDatasetSuggestion(keyword, idElement) {

        // LOADING : starts
        this.loadingIn(this.tagsImport.datasetFilterAutocomplete.builtTemplate);

        let usrReq_url: string = '/api/search/tag/dataset/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON({keyword: keyword})]);

        this.executeXHR('getDatasetSuggestion', usrReq_url, usrReq_params, this.onDatasetOptionsReturn);
    }

    protected onDatasetOptionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data.templateTypes) {

                    let templateOptions = response.data.templateTypes;
                    obj.tagsImport.setDatasetOptions(templateOptions);
                }

            });
        }
    }

    protected getSuggestions(keyword, idSourceElement) {
        if (idSourceElement == "datasetFilterAutocomplete") {

            this.getDatasetSuggestion(keyword, 5);
        }
    }

    protected onAutocompleteInputClick(idElement) {

        if ( idElement == "datasetFilterAutocomplete" )
        {

            let filterTypes = this.tagsImport.datasetFilterAutocomplete.getTemplateViewModel();

            if (filterTypes.addNewSelected())
            {
                this.tagsImport.datasetFilterAutocomplete.setOptions([]);

            }
        }
    }

    protected onAutocompleteOptionChange(idElement) {

        if (idElement == "datasetFilterAutocomplete") {
            let dataset = this.tagsImport.datasetFilterAutocomplete.getTemplateViewModel().optionObj();
            if (dataset) {
                this.tagsImport.getTemplateViewModel().selectedDataset(dataset)
            }
        }
    }

    protected onAutocompleteInputClear(idElement){

        if (idElement == "datasetFilterAutocomplete") {
            let dataset = this.tagsImport.datasetFilterAutocomplete.getTemplateViewModel().optionObj();
            this.tagsImport.getTemplateViewModel().selectedDataset(dataset)
        }
    }

    protected buildImportRequestUrl(): string {
        let brandUrl = this.isBrand() ? `/brand/${this.getBrandId()}` : '';
        let url: string = `/api${brandUrl}/tags/import/`;
        return url;
    }

    public isBrand(): boolean {
        let number = Number(this.getBrandId());
        return Number.isInteger(number);
    }

    protected importTags() {
        const tagImportData = this.tagsImport.getViewModelForImportRequest()

        if(tagImportData.csvFile == null) {
            this.validationTemplate.setSingleMessage({
                field: 'csvFile',
                label: 'CSV File',
                message: 'Please select a file'
            });
        }
        else {
            // LOADING : starts
            this.loadingIn(this.tagsImport.builtTemplate);

            let formReq_url: string = this.buildImportRequestUrl();
            var formData = new FormData();

            formData.append("csvTags", tagImportData.csvFile);
            formData.append("idBrand", tagImportData.idBrand);
            formData.append("datasetName", tagImportData.datasetName);
            formData.append("isImportOnlyMissingData", tagImportData.isImportOnlyMissingData);

            let request = [];
            let xhttp = new XMLHttpRequest();
            request["request"] = xhttp;

            // Set POST method and ajax file path
            xhttp.open("POST", formReq_url, true);

            let onReadyStateFunction = this.onImportTagsReturn

            // call on request changes state
            xhttp.onreadystatechange = onReadyStateFunction(request, this);
            xhttp.send(formData);
        }

    }

    protected onImportTagsReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Tags imported successfully!');
                obj.backAction();
            });
            obj.tagsImport.clearFileSelection();
            obj.loadingOut(obj.tagsImport.builtTemplate);
        }
    }

    protected cancel() {
        this.backAction();
    }

    private backAction() {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect(`/brand/${idBrand}/categorization/tags/`);
    }

    protected getMemoryViewModel() {
    }

    public getBrandId(): number {
        return Number(this.getVnAppZone().app.params.idBrand);
    }

    protected buildListRequestUrl() {
        let url = '/categorization/tags'
        let brandURL = this.isBrand() ? `/brand/${this.getBrandId()}` : '';
        url = `${brandURL}${url}`
        return url;
    }

    protected onAutocompleteAddNewSelected(idElement) {
        if(idElement == "datasetFilterAutocomplete"){
            if(this.tagsImport.datasetFilterAutocomplete.getTemplateViewModel().addNewSelected()) {
                this.tagsImport.setNewDatasetName(this.tagsImport.datasetFilterAutocomplete.getTemplateViewModel().newOptionName());
            }
            else {
                this.tagsImport.setNewDatasetName(null);
            }
        }
    }

    protected onAutocompleteAddNewInputClick(idElement){}

    protected onAutocompleteAddNewInputChange(idElement){

        if(idElement == "datasetFilterAutocomplete"){
            this.tagsImport.setNewDatasetName(this.tagsImport.datasetFilterAutocomplete.getTemplateViewModel().newOptionName());
        }
    }

    protected getTagTypeDatasetPairs(keyword,idElement){
        this.cancelXHR('getTagTypeDatasetPairs');

        // LOADING : starts
        this.loadingIn(this.tagsImport.builtTemplate.querySelector('#tag-update-predictions'));

        let url: string = `/api/brand/${this.getBrandId()}/tags/import/tagtypedataset/`;

        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(this.tagsImport.getViewModelForTagTypeDatasetPairsRequest())] );

        this.executeXHR('getTagTypeDatasetPairs', url, params, this.onGetTagTypesSuggestionReturn);
    }

    protected onGetTagTypesSuggestionReturn(req, obj) {
        return function () {

            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data) {
                    let templateOptions = response.data;
                    obj.tagsImport.setExistingTagTypes(templateOptions);
                }
            });
            obj.loadingOut(obj.tagsImport.builtTemplate.querySelector('#tag-update-predictions'));
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/tags_import.ts